"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Exchange_exports = {};
__export(Exchange_exports, {
  default: () => Exchange_default
});
module.exports = __toCommonJS(Exchange_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.1602 14.8984L16.5742 10.4844C16.7435 10.3281 16.9388 10.25 17.1602 10.25C17.3945 10.25 17.5964 10.3281 17.7656 10.4844C17.9219 10.6536 18 10.8555 18 11.0898C18 11.3112 17.9219 11.5065 17.7656 11.6758L13.3516 16.0898H16.3398C16.5612 16.0898 16.75 16.1745 16.9062 16.3438C17.0755 16.5 17.1602 16.6888 17.1602 16.9102C17.1602 17.1445 17.0755 17.3464 16.9062 17.5156C16.75 17.6719 16.5612 17.75 16.3398 17.75H11.3398C11.1055 17.75 10.9036 17.6719 10.7344 17.5156C10.5781 17.3464 10.5 17.1445 10.5 16.9102V11.9102C10.5 11.6888 10.5781 11.5 10.7344 11.3438C10.9036 11.1745 11.1055 11.0898 11.3398 11.0898C11.5612 11.0898 11.75 11.1745 11.9062 11.3438C12.0755 11.5 12.1602 11.6888 12.1602 11.9102V14.8984ZM7.64844 4.41016H4.66016C4.4388 4.41016 4.24349 4.33203 4.07422 4.17578C3.91797 4.00651 3.83984 3.8112 3.83984 3.58984C3.83984 3.35547 3.91797 3.16016 4.07422 3.00391C4.24349 2.83464 4.4388 2.75 4.66016 2.75H9.66016C9.89453 2.75 10.0898 2.83464 10.2461 3.00391C10.4154 3.16016 10.5 3.35547 10.5 3.58984V8.58984C10.5 8.8112 10.4154 9.00651 10.2461 9.17578C10.0898 9.33203 9.89453 9.41016 9.66016 9.41016C9.4388 9.41016 9.24349 9.33203 9.07422 9.17578C8.91797 9.00651 8.83984 8.8112 8.83984 8.58984V5.60156L4.42578 10.0156C4.25651 10.1719 4.05469 10.25 3.82031 10.25C3.59896 10.25 3.40365 10.1719 3.23438 10.0156C3.07812 9.84635 3 9.65104 3 9.42969C3 9.19531 3.07812 8.99349 3.23438 8.82422L7.64844 4.41016Z",
      fill: "currentColor"
    }
  )
);
const SvgExchange = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Exchange_default = SvgExchange;
